import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

interface IMatchParams {
	userId: string
}
export const UserKycMain = () => {

	const profileAvatar = require('../images/avatar-bg.svg')

	const user = useSelector((state: IState) => state.userDetails)
	const kyc = useSelector((state: IState) => state.kycDetails)

	const { userId } = useParams<IMatchParams>()
	React.useEffect(
		() => {
			ws.send({ type: 'KycDetails.Get', userId } as any)
		},
		[])

	const tags: any = {
		unverified: 'tagPurple',
		pending: 'tagYellow',
		verified: 'tagGreen',
		blocked: 'tagRed',
		admin: 'tagBlack',
		operator: 'tagGrey'
	}

	const verify = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'KycDetails.Verify', userId } as any)
		}
	}

	const clear = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'KycDetails.Clear', userId } as any)
		}
	}

	const block = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'KycDetails.Block', userId } as any)
		}
	}

	const pdfIcon = require('../images/pdf.svg')

	const openImg = (img: string) => {
		window.open()!.document.body.innerHTML = `<img src='${img}' />`
	}

	return (
		<div className='ordersMain'>
			<span className='pageTitle'>KYC</span>
			<span className='pageBoxTitle'>User Details</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem dateColumn'>Register Date</td>
							<td className='ordersTableHeaderRowItem idColumn'>User ID</td>
							<td className='ordersTableHeaderRowItem'>Email</td>
							<td className='ordersTableHeaderRowItem dateColumn'>Last seen</td>
							<td className='ordersTableHeaderRowItem'>Status</td>
						</tr>
					</thead>
					<tbody>
						{user ?
							<tr className='ordersTableBodyRow'>
								<td className='ordersTableBodyRowItem'>{user.registerDate ? new Date(user.registerDate).toLocaleString('en-GB') : ''}</td>
								<td className='ordersTableBodyRowItem'>{Utils.pad(Utils.base32.encode(user.id || 0), 6)}</td>
								<td className='ordersTableBodyRowItem'>{user.email}</td>
								<td className='ordersTableBodyRowItem'>{user.lastSeen ? new Date(user.lastSeen).toLocaleString('en-GB') : ''}</td>
								<td className='ordersTableBodyRowItem'><span className={`profileFormTag ${tags[user.status || '']}`}>{user.status}</span></td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Actions</span>
			<div className='pageColumn3Box'>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonRed'>
						<button onClick={block} type='submit'>Block</button>
					</div>
				</div>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonYellow'>
						<button onClick={clear} type='submit'>Clear Data</button>
					</div>
				</div>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonGreen'>
						<button onClick={verify} type='submit'>Verify</button>
					</div>
				</div>
			</div>
			<br />
			<span className='pageBoxTitle'>Personal Data</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem'>Full Name</td>
							<td className='ordersTableHeaderRowItem'>Birth Date</td>
							<td className='ordersTableHeaderRowItem'>Account Type</td>
							<td className='ordersTableHeaderRowItem'>Tax ID Number</td>
						</tr>
					</thead>
					<tbody>
						{kyc ?
							<tr className='ordersTableBodyRow'>
								<td className='ordersTableBodyRowItem capitalize'>{kyc.fullName}</td>
								<td className='ordersTableBodyRowItem'>{kyc.birthdate ? new Date(kyc.birthdate).toLocaleString('en-GB').split(', ')[0] : ''}</td>
								<td className='ordersTableBodyRowItem capitalize'>{kyc.docTypeId}</td>
								<td className='ordersTableBodyRowItem'>{kyc.docIdNumber}</td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Address Info</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem'>Street Address</td>
							<td className='ordersTableHeaderRowItem'>City</td>
							<td className='ordersTableHeaderRowItem'>State</td>
							<td className='ordersTableHeaderRowItem'>Postcode</td>
							<td className='ordersTableHeaderRowItem'>Country</td>
						</tr>
					</thead>
					<tbody>
						{kyc ?
							<tr className='ordersTableBodyRow'>
								<td className='ordersTableBodyRowItem capitalize'>{kyc.streetAddress}</td>
								<td className='ordersTableBodyRowItem capitalize'>{kyc.city}</td>
								<td className='ordersTableBodyRowItem capitalize'>{kyc.state}</td>
								<td className='ordersTableBodyRowItem'>{kyc.postcode}</td>
								<td className='ordersTableBodyRowItem'>{kyc.country}</td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Uploads</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem'>Document ID Photo</td>
							<td className='ordersTableHeaderRowItem'>Selfie holding ID Photo</td>
							<td className='ordersTableHeaderRowItem'>Proof of Residence</td>
						</tr>
					</thead>
					<tbody>
						<tr className='ordersTableBodyRow'>
							<td className='ordersTableBodyRowItem photoColumn'>
								{!kyc?.docIdPic
									?
									<img src={profileAvatar} className='kycUpload' alt='Document ID Photo' />
									: kyc.docIdPic.startsWith('data:image')
										?
										<a href='#' onClick={() => openImg(kyc.docIdPic)}>
											<img src={kyc.docIdPic} className='kycUpload' alt='Document ID Photo' />
										</a>
										:
										<a href={kyc.docIdPic} download='docIdPic.pdf'>
											<img src={pdfIcon} className='kycUpload' alt='Document ID Photo' />
										</a>
								}
							</td>
							<td className='ordersTableBodyRowItem photoColumn'>
								{!kyc?.selfiePic
									?
									<img src={profileAvatar} className='kycUpload' alt='Selfie holding ID Photo' />
									: kyc.selfiePic.startsWith('data:image')
										?
										<a href='#' onClick={() => openImg(kyc.selfiePic)}>
											<img src={kyc.selfiePic} className='kycUpload' alt='Selfie holding ID Photo' />
										</a>
										:
										<a href={kyc.selfiePic} download='selfiePic.pdf'>
											<img src={pdfIcon} className='kycUpload' alt='Selfie holding ID Photo' />
										</a>
								}
							</td>
							<td className='ordersTableBodyRowItem photoColumn'>
								{!kyc?.proofResPic
									?
									<img src={profileAvatar} className='kycUpload' alt='Proof of Residence' />
									: kyc.proofResPic.startsWith('data:image')
										?
										<a href='#' onClick={() => openImg(kyc.proofResPic)}>
											<img src={kyc.proofResPic} className='kycUpload' alt='Proof of Residence' />
										</a>
										:
										<a href={kyc.proofResPic} download='proofResPic.pdf'>
											<img src={pdfIcon} className='kycUpload' alt='Proof of Residence' />
										</a>
								}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div >
	)
}



// WEBPACK FOOTER //
// ./src/components/userKycMain.tsx